var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoltage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21.18C17.0699 21.18 21.18 17.0699 21.18 12C21.18 6.92998 17.0699 2.81995 12 2.81995C6.92998 2.81995 2.81995 6.92998 2.81995 12C2.81995 17.0699 6.92998 21.18 12 21.18ZM12 22.8C17.9646 22.8 22.8 17.9646 22.8 12C22.8 6.03528 17.9646 1.19995 12 1.19995C6.03528 1.19995 1.19995 6.03528 1.19995 12C1.19995 17.9646 6.03528 22.8 12 22.8Z",
    fill: "#4E5968"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.81 5.51996C12.81 5.07261 12.4473 4.70996 12 4.70996C11.5526 4.70996 11.19 5.07261 11.19 5.51996V7.94996H8.75995C8.3126 7.94996 7.94995 8.31261 7.94995 8.75996C7.94995 9.20731 8.3126 9.56996 8.75995 9.56996H11.19V12C11.19 12.4473 11.5526 12.81 12 12.81C12.4473 12.81 12.81 12.4473 12.81 12V9.56996H15.24C15.6873 9.56996 16.05 9.20731 16.05 8.75996C16.05 8.31261 15.6873 7.94996 15.24 7.94996H12.81V5.51996Z",
    fill: "#4E5968"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94995 17.4C7.94995 16.9526 8.3126 16.59 8.75995 16.59H15.24C15.6873 16.59 16.05 16.9526 16.05 17.4C16.05 17.8473 15.6873 18.21 15.24 18.21H8.75995C8.3126 18.21 7.94995 17.8473 7.94995 17.4Z",
    fill: "#4E5968"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoltage);
export default __webpack_public_path__ + "static/media/Voltage.615423e14ae2ce2747909ed46a7c0937.svg";
export { ForwardRef as ReactComponent };